export default {
  relationships: {
    listing: {
      type: 'market_listings'
    }
  }
}